import { formatCalendarDate, todayYmd } from '../../../utils/appTimezone';

function toYmd(value) {
  if (value == null || value === '') return null;
  const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
}

export function formatDateShort(isoDate) {
  return formatCalendarDate(isoDate, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

export function formatRestDayPatientLabel(item) {
  const name = item?.patient_name;
  if (name != null && String(name).trim() !== '') {
    return String(name).trim();
  }
  return 'Patient non renseigné';
}

export function getPatientInitials(name) {
  if (!name || typeof name !== 'string') return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function isRestDayInProgress(item) {
  if (!item || item.status !== 'ISSUED') return false;
  const start = toYmd(item.start_date);
  const end = toYmd(item.end_date);
  if (!start || !end) return false;
  const today = todayYmd();
  return today >= start && today <= end;
}

export function getRestDayStatusPillProps(status, copy) {
  const isIssued = status === 'ISSUED';
  return {
    label: isIssued ? copy.STATUS_ISSUED : copy.STATUS_CANCELLED,
    className: `hd-rest-status-pill hd-rest-list__status hd-rest-status-pill--${
      isIssued ? 'issued' : 'cancelled'
    }`
  };
}

export function getRestDayDurationPillProps(daysCount, copy) {
  const count = Number(daysCount);
  if (!Number.isFinite(count) || count < 1) return null;
  return {
    label: `${count} ${copy.DAYS_SUFFIX}`,
    className: 'hd-rest-duration-pill hd-rest-list__duration'
  };
}

export function formatRestDayPeriod(item) {
  const start = formatDateShort(item?.start_date);
  const end = formatDateShort(item?.end_date);
  if (start === '—' || end === '—') return '';
  return `${start} → ${end}`;
}

/**
 * Ligne secondaire : contexte hors période / durée / statut (déjà en badges).
 */
export function buildRestDayListSecondaryLine(item, copy) {
  const parts = [];

  if (item.member_matricule) {
    parts.push(item.member_matricule);
  }

  if (item.consultation_date) {
    parts.push(`${copy.CONSULT_PREFIX} ${formatDateShort(item.consultation_date)}`);
  } else if (item.consultation_id) {
    parts.push(`${copy.CONSULT_PREFIX} #${item.consultation_id}`);
  }

  if (item.doctor_name) {
    parts.push(item.doctor_name);
  }

  if (item.clinical_motif?.trim()) {
    parts.push(item.clinical_motif.trim());
  }

  if (item.recommendations?.trim()) {
    parts.push(item.recommendations.trim());
  }

  return parts.join(' · ');
}

export function computeRestDaySiteTotals(items = []) {
  const issued = items.filter((item) => item.status === 'ISSUED');
  return {
    issued: issued.length,
    cancelled: items.filter((item) => item.status === 'CANCELLED').length,
    totalDays: issued.reduce((sum, item) => sum + (Number(item.days_count) || 0), 0),
    inProgress: issued.filter(isRestDayInProgress).length
  };
}
